module.exports = __webpack_public_path__ + "pt.2f33a7e78cc207218327.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/pt.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/pt.svg
// module chunks = styles